import { render, staticRenderFns } from "./PrizesDialog.vue?vue&type=template&id=5d13ef32&scoped=true&"
import script from "./PrizesDialog.vue?vue&type=script&lang=ts&"
export * from "./PrizesDialog.vue?vue&type=script&lang=ts&"
import style0 from "./PrizesDialog.vue?vue&type=style&index=0&id=5d13ef32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d13ef32",
  null
  
)

export default component.exports